module.exports = __webpack_public_path__ + "static/img/product-poster-1.0919836a.png";